import { AlertCircle, ArrowLeft, Bell, Building, ChevronLeft, ChevronRight, Home, Plus, RefreshCcw, User } from "lucide-react";

const _FAHERO = {
  home: Home,
  building: Building,
  "arrow-left": ArrowLeft,
  "chevron-left": ChevronLeft,
  "chevron-right": ChevronRight,
  user: User,
  bell: Bell,
  plus: Plus,
  spinner: RefreshCcw,
  "exclamation-circle": AlertCircle,
};

export default function AppIcon({ code = "", className = "", ...props }) {
  if (!code || !_FAHERO[code]) return <></>;
  const Icon = _FAHERO[code];
  return <Icon className={className} {...props} />;
}
